import React, { Component, Fragment } from 'react';
import IframeComm from 'react-iframe-comm';
import ReactGA from 'react-ga';

import Paragraph from '../../collections/Paragraph/Paragraph';
import SessionStorage from '../../storage/SessionStorage/SessionStorage';

class EComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            step: 1,
            iframeHeight: 200,
            ecompState: '',
            hideFrame: false
        }

        this.updateSessionData = this.updateSessionData.bind(this);
        this.onReceiveMessage = this.onReceiveMessage.bind(this);
    };

    componentDidMount() {
        ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID);
        this.props.update({loading: true});
        this.props.handleFormPrompt(true);
    }

    updateSessionData(event) {
        SessionStorage.setSessionStorageItem('bal', '4061ddbfe486cce727972d8abc85171005b2911c3fb21aabd2481bab12fdba1b');
        this.props.update({
            loading: true, 
            accessBalance: '4061ddbfe486cce727972d8abc85171005b2911c3fb21aabd2481bab12fdba1b'
        });
        this.props.handleErrorMessage(false, '', `error`);
        this.props.handleFormPrompt(false);

        this.props.update({loading: false}, () => {
            this.props.history.push(this.props.generateURIFromCode(this.props.appState.code, 'balance'))
        });

    }

    onReady = () => {
        this.props.update({loading: false});
    }

        onReceiveMessage = (message) => {

            switch (message.data) {
                case 'AUTHENTICATION':
                    this.sendEvent('CardActivation', 'Journey', 'PINRetrievalUserCredentials');
                    this.setState({iframeHeight: 300, ecompState: '', hideFrame: false})
                    break;
                case 'CARD_ACTIVATION':
                    this.setState({iframeHeight: 220, ecompState: ''})
                    break;
                case 'SECOND_SECURITY_FACTOR': 
                    this.sendEvent('CardActivation', 'Journey', 'PINRetrievalCVC');
                    this.setState({iframeHeight: 300, ecompState: ''})
                    break;
                case 'DISPLAY_PIN': 
                    this.sendEvent('CardActivation', 'Journey', 'PINRetrievalPINReveal');
                    this.setState({iframeHeight: 300, ecompState: 'DISPLAY_PIN'}, () => {
                        if (parseInt(SessionStorage.getSessionStorageItem('Activate'), 10) === 0) {
                            this.sendEvent('CardActivation', 'Process', 'DisplayPin')
                        } else {
                            this.sendEvent('CardActivation', 'Process', 'ForgottenPin')
                        }
                    })
                    break;
                case 'FINAL_STEP': 
                    this.sendEvent('CardActivation', 'Journey', 'PINRetrievalExitMessage');
                    this.setState({iframeHeight: 200, ecompState: '', hideFrame: true})
                    this.updateSessionData();
                    break;
                default:
            }
        }

        sendEvent = (category, action, label) => {
            ReactGA.event({
                category: category,
                action: action,
                label: label
            })
        }
  
        render() {

            const attributes = {
                src: this.props.appState.eComponentURL,
                width: "100%",
                height: this.state.iframeHeight
            };

            return (
              <Fragment>
                { this.state.ecompState === 'DISPLAY_PIN' ? 
                  <Paragraph center textColor={this.props.appState.ui.pinRetrieval.card.titleTextColor} mbottom={'2rem'}>{'Your PIN will be revealed one digit at a time and can be displayed up to three times.'}</Paragraph>
          : 
            null
    }
        
    { this.state.hideFrame ? 
      null
    : 
      <IframeComm attributes={attributes} handleReady={this.onReady} handleReceiveMessage={this.onReceiveMessage} />
    }
  </Fragment>
)
    }
    };

export default EComponent;


// WEBPACK FOOTER //
// ./src/containers/PinRetrievalPage/Step2.js